import request from "@/utils/request"
import storage from 'store'
import { TENANT } from '@/store/mutation-types'

const api = {
    page: '/admin/systemGroupPerm/page',
    listSystemIdByGroupId: '/admin/systemGroupPerm/listSystemByGroupId',
    add: '/admin/systemGroupPerm/add',
    edit: '/admin/systemGroupPerm/edit',
    delete: '/admin/systemGroupPerm/delete',
    addSystem: '/admin/systemGroupPerm/addSystem',
    addUser: '/admin/systemGroupPerm/addUser',
    hasIsAdminGroup: '/admin/systemGroupPerm/hasIsAdminGroup'
}

export function pageGroupPerm(parameter) {
    return request({
        url: api.page,
        method: 'get',
        params: parameter
    })
}

export function addGroupPerm(parameter) {
    return request({
        url: api.add,
        method: 'post',
        data: parameter
    })
}

export function editGroupPerm(parameter) {
    return request({
        url: api.edit,
        method: 'post',
        data: parameter
    })
}

export function listSystemByGroupId(parameter) {
    return request({
        url: api.listSystemIdByGroupId,
        method: 'get',
        params: parameter
    })
}

export function deleteGroupPerm(parameter) {
    return request({
        url: api.delete,
        method: 'post',
        data: parameter
    })
}

export function addSystem(parameter){
    return request({
        url: api.addSystem,
        method: 'post',
        data: parameter
    })
}

export function addUser(parameter){
    return request({
        url: api.addUser,
        method: 'post',
        data: parameter
    })
}

export function hasIsAdminGroup(){
    return request({
        url: api.hasIsAdminGroup,
        method: 'get'
    })
}
